
import { Field } from "../../components/types/stylepacks";
import { GraphicInterface } from "../reducers/graphics";
import { MediaItem } from "../reducers/media";

export type Blur = 'high' | 'low' | 0;

export interface VirtualBg {
	uniqueId: string;
	url: string;
	blur: Blur;
	id?: number; // id of database entry
	thumbnail?: string;
	name?: string;
	fileType?: string;
}

export interface TemplateData {
	apiVersion: string;
	config?: {
		[key: string]: any;
	};
	thumbnail: {
		id: string;
		url: string;
		title: string;
		width: number;
		height: number;
		contentType: string;
	};
	variables: Field[];
	duration?: number;
}

export interface GeneratedContentRequest {
	templateId: number;
	id: number;
	fkTable: FkTable;
	fkId?: number;
	version: number;
	graphic?: GraphicInterface;
	mediaItem?: MediaItem;
	data: GeneratedContentData[];
	contentUrl: string;
	jobId?: string;
	jobStatus?: string;
}

export interface GeneratedContentData {
	key: string;
	value: string;
}

export enum ContentServiceJobStatus {
	completed = 'completed',
	processing = 'processing',
	exporting = 'exporting',
	failed = 'failed',
}

export enum FkTable {
	graphics = 'gr_graphics',
	media = 'gr_media',
}

export interface GeneratedContent {
	id?: number;
	templateId: number;
	dateCreated?: Date;
	createdBy?: number;
	dateUpdated?: Date;
	updatedBy?: number;
	jobId?: string;
	jobStatus?: ContentServiceJobStatus;
	contentUrl?: string;
	provider: string;
	type: string;
	fkTable: FkTable;
	fkId?: number;
	data: GeneratedContentData[];
	config?: {
		[key: string]: any;
	};
	themeId?: number;
	currentThemeVersion?: number;
	version: number;
	apiVersion?: string;
}

export interface RegeneratingContent {
	id: number;
	version: number;
}